<template>
  <!--基本信息的考试须知区 -->
  <div
    class="basics-desc"
    :class="{'trd-desc': answerSheet.acCardPanes == 3}"
    :style="{ width: isCW ? contW + 41 + 20 + 'px' : 'auto'}"
  >
    <div class="d-name"
>
      <div class="n-p">
        考试
        <br />须知
      </div>
    </div>
    <div class="d-cont" >
      <p>1.答题前请将个人信息填写清楚。</p>

      <p>2.客观题答题修改时用橡皮擦干净。</p>

      <p>3.主观题必须使用黑色签字笔书写。</p>

      <p>4.请在题号对应答题区内作答,超出书写无效。</p>
      <!-- <p class="d-cont-row" v-for="(item,index) in tips" :key="index">
        {{index + 1}}. {{item.pre}} <span v-if="item.middle" class="blod-cont" style="font-weight: 700; color: #333333 !important">{{item.middle}}</span> {{item.end}}
      </p> -->
      <BasicsExampleImage/>
<!-- 
      <p class="BasicsExampleImage_wrap">
      </p> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BasicsExampleImage from './BasicsExampleImage'

//基础信息区
export default {
  name: "basicsDesc",
  components:{
    BasicsExampleImage
  },
  props: {
    sty: String,
    isCW: Boolean,
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      basicsCheckList: (state) => state.basicsCheckList, //选中的信息
    }),
    ...mapState("cardMake", ["pageCellSize"]), //答卷设置参数
    contW() {
      if (this.answerSheet.acCardPanes == 3) {
        let w;
        if (this.answerSheet.acCardStudentCodeType == 1) {
          w = this.pageCellSize[1] - 301 - 2 - 41 - 20;
        } else {
          w =
            this.pageCellSize[1] -
            this.answerSheet.acCardExamNumber * 28 -
            41 -
            20 -
            2;
        }
        return w;
      } else {
        let w;
        if (this.answerSheet.acCardStudentCodeType == 1) {
          w = this.pageCellSize[0] - 301 - 2 - 41 - 20;
        } else {
          w =
            this.pageCellSize[0] -
            this.answerSheet.acCardExamNumber * 28 -
            41 -
            20 -
            2;
        }
        return w;
      }
    },
  },
  data() {
    return {
      tips: []
    };
  },
  created() {
  },
  mounted(){
    // this.setUpTips()
  },
  methods: {
    setUpTips() {
      let tipCheck = ''
      this.basicsCheckList.forEach((item,index) => {
        tipCheck += `${index != this.basicsCheckList.length - 1 ? (item + '、') : ('和 ' + item)}`
      });
      this.tips = [
        {
          pre: "答题前，考生务必认真核准条形码上的个人信息是否无误，并将核准后的条形码粘贴在指定区域，然后将",
          middle: tipCheck,
          end: '填写在答题卡相应位置。',
        },
        {
          pre: "答选择题时，必须使用 ",
          middle: " 2B 铅笔",
          end: "涂答题卡上相应题目的答案标号，修改时，要用橡皮擦干净，再选择填涂其他答案。",
        },
        {
          pre: "答非选择题时，必须使用",
          middle: " 0.5 毫黑色签字笔，",
          end: "在题号所指示的答题区域内书写作效。要求字体工整，笔迹清晰。答案超出答题区域书写的答案无效，要求字体工整，笔记清晰。",
        },
        {
          pre: "须保持答题卡清洁、完整，严禁折叠，严禁做任何标记，严禁使用涂改液、修正带。",
          middle: "",
          end: "",
        },
      ];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.basics-desc {
  border: 1px solid #000000;
  // border-top: 0;
  display: flex;
  flex-flow: row;
  &.trd-desc {

    .d-cont {
      white-space: nowrap;
       p {
        font-size: 11px
       }
    }
  }
  .d-name {
    background: #f2f2f2;
    width: 40px;
    line-height: 25px;
    text-align: center;
    border-right: 1px solid #000000;
    display: flex;
    align-items: center;
  }

  .d-cont {
    color: var(--card-color);
    display: flex;
    flex-direction: column;
    flex: 1;
    .d-cont-row {
      padding-top: 3px;
      line-height: 20px;
      .blod-cont {
        display: inline-block;
        white-space: nowrap;
      }
    }
  }

  .n-p {
    text-align: center;
    width: 100%;
  }
}
.basics-desc {
  border-color: var(--card-color) !important;
  border-top: none !important;
  .d-name {
    border-right-color: var(--card-color) !important;
    color: var(--card-color)
  }
}
</style>
